export default {
    namespaced: true,
    state: {
        // 因为该页面是唯一出现的，所以只需要记录传入的 items、option
        items: [],
        options: [],
    },
    actions: {},
    mutations: {
        UPDATE_DATA: function (state, val) {
            var _a = val || {}, items = _a.items, options = _a.options;
            state.items = Array.isArray(items) ? items : [];
            state.options = Array.isArray(options) ? options : [];
        }
    },
    getters: {}
};
